/**
 * Silent loops for link previews (`og:video`). Messages on iOS and macOS
 * downloads a direct MP4 named by `og:video` and plays it in the bubble
 * (Apple TN3156); Discord and Telegram do the same. Everything else keeps
 * showing `og:image`.
 *
 * Made in the video-agent project; masters, posters and sources are in
 * ~/Downloads/ppfengine-videos/og-previews/. Spec, set by Apple's limits:
 * 1200 × 630 like og.png, H.264, no audio, faststart, a few MB at most
 * (a whole preview, icon and image included, is capped at 10 MB).
 *
 * The files sit in static/og/, but pages link them through /video/<clip>.mp4
 * (routes/video/[file]): the static asset server answers a Range request with
 * the whole file and a 200, and iOS media playback wants 206 slices.
 */
export const ogVideoClips = ['home', 'amg-gt-bumper', 'ram-flare', 'bmw-x3-cap'] as const;

export type OgVideoClip = (typeof ogVideoClips)[number];

export const ogVideo = { width: 1200, height: 630, type: 'video/mp4' } as const;

export function isOgVideoClip(value: string): value is OgVideoClip {
	return (ogVideoClips as readonly string[]).includes(value);
}

/** Public URL path, the one meta tags use. */
export const ogVideoPath = (clip: OgVideoClip) => `/video/${clip}.mp4`;

/** Where the file sits among the static assets. */
export const ogVideoAsset = (clip: OgVideoClip) => `/og/${clip}.mp4`;
